let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("feg87"), load("gGI57"), load("lPCqB"), load("iaptT")]).then(() => parcelRequire('hB4M9'));